<ng-container>
  <main role="main" class="pre-loader logout-pg">
    <section>
      <h1>You have successfully logged out.</h1>
      <p>Not a user? <a href="https://www.amilearn.ca">Find out more</a></p>
      <p>Need Support? Contact <a href="mailto:support@meetami.ca">support@meetami.ca</a>.</p>
    </section>
  </main>
</ng-container>
